module.exports = __webpack_public_path__ + "img/icon-select-arrow.41916a00.svg";